// range-size helpers shared by the report query schemas. both count INCLUSIVE
// spans, so a from/to landing on the same day is 1 day / 1 month.

const DAY_MS = 24 * 60 * 60 * 1000

const utcFromIso = (iso: string): Date => new Date(`${iso}T00:00:00Z`)

/** inclusive count of calendar months a from/to range touches */
export const monthsInRange = (fromIso: string, toIso: string): number => {
  const from = utcFromIso(fromIso)
  const to = utcFromIso(toIso)
  return (
    (to.getUTCFullYear() - from.getUTCFullYear()) * 12 + (to.getUTCMonth() - from.getUTCMonth()) + 1
  )
}

/** inclusive count of days a from/to range covers */
export const daysInRange = (fromIso: string, toIso: string): number => {
  const from = utcFromIso(fromIso)
  const to = utcFromIso(toIso)
  return Math.round((to.getTime() - from.getTime()) / DAY_MS) + 1
}
